@if (status()) {
    <span class="relative inline-flex items-center">
        <sh-tag
            data-testid="details-header-container-status"
            [attr.data-status]="status()"
            [attr.data-on-hold]="isOnHold()"
            [class]="isOnHold() ? '[--sh-tag-padding:0_0.5rem_0_1.5rem]' : ''"
            [color]="statusColorMap[status()]"
            [label]="'common.status.' + (isInternal() ? 'internal.' : 'external.') + status() | translate"
            [condensed]="size() === 'sm'"
            active
        ></sh-tag>
        @if (isOnHold()) {
            <span class="pointer-events-none absolute inset-y-0 left-1.5 flex items-center">
                <sh-icon data-testid="details-header-icon-on-hold" icon="pause-circle" size="xs"></sh-icon>
            </span>
        }
    </span>
}
